import { render } from "./NItem.vue?vue&type=template&id=0c537290&scoped=true"
import script from "./NItem.vue?vue&type=script&lang=js"
export * from "./NItem.vue?vue&type=script&lang=js"

import "./NItem.vue?vue&type=style&index=0&id=0c537290&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c537290"]])

export default __exports__